import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SeleccionInformesScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { ImportacionesLogAdapter } from '../../../../../../infraestructure/persistence/rest/ImportacionesLogAdapter';

import { downloadFile } from '../../../../../../shared/utils/download';

export const LogImportacionesContainer = () => {

	const api = new ImportacionesLogAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [ dataDetalle, setDataDetalle ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);

	let result: any;

	const filtrarImportaciones = async (data: any) => {
		setIsLoading(true);
		try {
			result = await api.ListarCabeceras(data);
			if(result.data && result.data!=="")
			{
				setData(result.data);
				setDataDetalle([]);
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};
	
	const filtrarDetalleImportacion = async (data: any) => {
		//setIsLoading(true);
		try {
			result = await api.ListarDetalle(data);
			if(result.data && result.data!=="")
			{
				//setDataDetalle(result.data);
				console.log('filtrarDetalleImportacion ', result.data)
				return result.data;
			}else{resultError(); return [];}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
			return [];
		}
		//setIsLoading(false);
  	};

	return (
		<>
			<SeleccionInformesScreen data={data} dataDetalle={dataDetalle} onFilter={filtrarImportaciones} onDetalleFilter={filtrarDetalleImportacion} isLoading={isLoading} />
		</>
	);
};

export default LogImportacionesContainer;